let initialState = {
    friends: [
    {id: 1, name: 'Egor', photo: 'https://i.pinimg.com/originals/86/95/54/8695540db1e9224367ed9d1a4884ccfc.jpg'},
    {id: 2, name: 'Slavik', photo: 'https://cspromogame.ru//storage/upload_images/avatars/3884.jpg'},
    {id: 3, name: 'Marta', photo: 'https://info-kibersant.ru/wp-content/uploads/2021/04/unnamed.jpg'},]
}

const sidebarReducer = (state = initialState, action) => {
    return state;
}

export default sidebarReducer;